module.exports = __webpack_public_path__ + "img/companyIcon.7d609fa4.svg";